import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Amplify } from 'aws-amplify';
import config from './aws-exports';
import 'bootstrap/dist/css/bootstrap.min.css';

Amplify.configure({
  ...config,
  Storage: {
    ...config.Storage,
    region: 'us-east-1' // replace 'us-west-2' with your actual region
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ✅ Register service worker for PWA behavior
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        //console.log('ServiceWorker registered: ', registration.scope);
      })
      .catch((error) => {
        //console.log('ServiceWorker registration failed: ', error);
      });
  });
}

// CRA perf util (optional)
reportWebVitals();
